import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { groupBy } from 'lodash';
import { translate } from '../Services/translation';

export const boldSubstr = (baseString, _substr) => {
    const substr = decodeURIComponent(_substr).trim();
    if (!baseString) {
        return '';
    }
    return baseString.replace(new RegExp(substr, 'ig'), (match) => {
        return `<b>${match}</b>`
    });
}

const ProductQuickSearchResult = ({ selectedItem, searchUrl, onClose, query, isHomeSearch = false, onlyProducts = false }) => {
    let items = <></>;
    const {
        result
    } = useSelector((state) => state.quickSearch);


    const searchResultsRef = useRef(null);
    
    const handleClickOutside = (event) => {
        if (searchResultsRef.current && !searchResultsRef.current.contains(event.target)) {
            onClose();
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const _data = (Object.entries(groupBy(result, ({ searchDisplayName }) => searchDisplayName))).filter(item => item[0] !== 'null');

    return <div className="quick-search-result" ref={searchResultsRef}>
        {
            _data.length ? _data.map(item => <div className="" key={`li-${item[0]}`}>
                <p className='searchheader' dangerouslySetInnerHTML={{ __html: boldSubstr(item[0], item[0]) }}>
                </p>
                <div className="tabs-content" data-tabs-content="collapsing-tabs">
                    <div key={`panel-${item[0].name}`} className="tabs-panel is-active" id={item[1].name}>
                        {item[1].map(__item =>
                            <div className="product-row">
                                {__item.imageIncluded && <div className='product-row__image'>
                                    {__item.imageSource ? <img src={__item.imageSource} /> : null}
                                </div>}
                                <div>
                                    <a className={`quick-search-result__link ${__item.url ? '' : 'quick-search-result__link--disabled'}`}
                                        href={__item.url}>
                                            {
                                                __item.imageSource ?
                                                <div className='quick-search-result__name' dangerouslySetInnerHTML={{ __html: boldSubstr(__item.name, query) }}></div>
                                                : 
                                                <div className='quick-search-result__category-name' dangerouslySetInnerHTML={{ __html: boldSubstr(__item.name, query) }}></div>
                                            }
                                    </a>
                                    <div className='quick-search-result__brand'>{__item.brand}</div>
                                    {__item.price > 0 && <div className='quick-search-result__price'>{__item.price},-</div>}
                                </div>
                            </div>)}
                    </div>
                </div>
            </div>) 
            : 
            <p className='quick-search-result__no-result'>{translate("coptikk.search.nohit")}</p>
        }
        {
            _data.length ?
            <a className={'quick-search-result__show-all button'}
                href={searchUrl}>
                <div>{(Object.entries(groupBy(result, ({ searchDisplayName }) => searchDisplayName))).find(item => item[0] === 'null')[1][0].name}</div>
            </a>
            : ""
        }
        {items}
        <i className="close" onClick={onClose}></i>
    </div>
}

export default ProductQuickSearchResult;